var MDB = window.MDB || {};
MDB.Charts = MDB.Charts || {};
MDB.Charts.renderers = MDB.Charts.renderers || {};

MDB.Charts.renderers.pivotGrid = function (widget, chart, data, metadata) {
    if (!data || data.length === 0) {
        widget.find('.loading-box').hide();
        return;
    }

    //TODO: Translate kendo
    
    setTimeout(function () {
        //Internally the Grid/DataSource seems to be doing something with the original data causing a stackoverflow to occur
        data = _.clone(data);
        
        MDB.Charts.emptyChartAndMakeVisible(widget, chart);
        
        var keyMappings = MDB.Charts.transformKeysToKendoFields(data);
        var keys = MDB.Charts.getDataKeys(data[0]);

        var kendoConfig = metadata.KendoConfig
            , withConfigurator = kendoConfig._withConfigurator;
        
        var containerCss = {
            width: '90%',
            height: '90%',
            top: '5%',
            left: '5%',
            position: 'relative',
            overflow: 'hidden'
        };
        
        var container = $('<div class="pivotgrid">').css(containerCss);
        
        if (!kendoConfig.dataSource) {
            kendoConfig.dataSource = {};
        } 
        if (!kendoConfig.dataSource.schema) {
            kendoConfig.dataSource.schema = {};
        } 
        if (!kendoConfig.dataSource.schema.model) {
            kendoConfig.dataSource.schema.model = {};
        } 
        if (!kendoConfig.dataSource.schema.cube) {
            kendoConfig.dataSource.schema.cube = {};
        }
        
        var fields = {};
        var cubeDimensions = {};
        var cubeMeasures = {};
        
        keys.forEach(function (field) {
            var originalKey = keyMappings.findByKey(field).originalKey;
            var fieldType = MDB.KendoConfigBuilder.getSchemaFieldType(data[0][field]);
            
            fields[field] = { 
                type: fieldType, 
                title:  originalKey
            };
            
            cubeDimensions[field] = {
                name: field, 
                caption:originalKey 
            };
            
            if (fieldType === 'number'){
                var measureType = 'SUM'
                    , measureName = field + '_' + measureType
                    , measureCaption = originalKey + '_' + measureType;
                
                cubeMeasures[measureName] = {
                    _type: 'SUM', 
                    
                    _measureName: measureName,
                    _measureCaption: measureCaption,
                    
                    field: field,
                    aggregate: function(value, state) {
                        return state.value = value + state.value || 0;
                    }
                }
            } 
        });

        kendoConfig.dataSource.data = data;
        kendoConfig.dataSource.schema.model.fields = fields;
        
        kendoConfig.dataSource.schema.cube.dimensions = cubeDimensions;
        kendoConfig.dataSource.schema.cube.measures = cubeMeasures;
        
        kendoConfig.dataSource.schema.measures = function() {
            return _.map(cubeMeasures, function (measure) {
                return {
                    name: measure._measureName,
                    caption: measure._fieldTitle + '_' + measure._type,
                    uniqueName: measure._measureName,
                    aggregator: measure._type
                }
            });
        };
        
        chart.height(MDB.Charts.calculateKendoChartMaxHeight(widget)).append(container);
       
        var gridContainer = container;
       
        if (withConfigurator){
            gridContainer = $('<div />').css({'width': '60%', 'height': '100%', 'display': 'inline-block'}).appendTo(container);
        } 
       
        gridContainer.kendoPivotGrid(kendoConfig);

        if (withConfigurator){
            var configuratorContainer = $('<div class="pivotgrid-configurator">').css({'width': '40%','height': '100%', 'display': 'inline-block'}).prependTo(container);

            configuratorContainer.kendoPivotConfigurator(kendoConfig);
        }
    }, 0);
};